__turbopack_context__.v({
  "contentsItem": "VNBpBG_contentsItem",
  "icon": "VNBpBG_icon",
  "svg__rg9Cj": "VNBpBG_svg__rg9Cj",
  "text16": "VNBpBG_text16",
});
